import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Map a 0-100 maturity score to a band {label, color, description, tone}.
 * Aligned with backend BAND_INSIGHTS in routes/maturity_assessment.py.
 */
export function getMaturityBand(score) {
  const s = Number(score) || 0;
  if (s >= 75) return {
    label: "Optimized", color: "#0d9488", tone: "emerald",
    description: "Predictive, AI-enhanced operations with continuous optimization.",
  };
  if (s >= 50) return {
    label: "Managed", color: "#0891b2", tone: "cyan",
    description: "Standardized processes with defined governance and measurable KPI correlations.",
  };
  if (s >= 25) return {
    label: "Developing", color: "#d97706", tone: "amber",
    description: "Defined but inconsistent processes with partial KPI alignment.",
  };
  return {
    label: "Emerging", color: "#dc2626", tone: "rose",
    description: "Fragmented governance with reactive portfolio management.",
  };
}
